export const environment = {
  production: false,
  baseUrl: 'https://backend-staging.braidsbook.com',
  apiUrl: 'https://backend-staging.braidsbook.com/api',
  placesApi: 'AIzaSyCMVu9q6pgpulb6xz6K1CsEj82smL2AEeo',
  recaptchaSiteKey: '6Ldh4FMrAAAAAF6vyYzJHSCwowZX69kE_T9IE781',
};
